import { Injectable } from '@angular/core';
import { AuthenticatedApiService } from './authenticated-api.service';
import { UserBuilder } from '../builders/user-builder';
import { ApiService } from './api.service';
import { getAuthToken, RESTClientConfig, setAuthToken } from '../rest-client.module';
import * as i0 from "@angular/core";
import * as i1 from "./authenticated-api.service";
import * as i2 from "./api.service";
import * as i3 from "../rest-client.module";
export class UsersApiService {
    constructor(authenticatedApi, unauthenticatedApi, restClientConfig) {
        this.authenticatedApi = authenticatedApi;
        this.unauthenticatedApi = unauthenticatedApi;
        this.restClientConfig = restClientConfig;
    }
    getUser() {
        return this.authenticatedApi.get('/user').toPromise().then(response => {
            return UserBuilder.buildUser(response.user);
        });
    }
    updateUser(user) {
        let payload = {
            email: user.email,
            name: user.name,
            lastname: user.lastName,
            phone: user.phone,
            zip: user.zipCode,
            accept_promos: user.accept_promos,
            accept_newsletter: user.accept_newsletter,
            default_invoice_profile: user.defaultInvoiceProfileId,
            lang: user.language,
            forced_lang: user.forced_lang,
            push_platform: user.pushPlatform,
            push_token: user.pushToken,
            app_rated: user.appRated,
            config: user.config
        };
        return this.authenticatedApi.put('/user', JSON.stringify(payload))
            .toPromise().then(response => UserBuilder.buildUser(response.user));
    }
    createUser(user, activationCode, id_reservation) {
        let payload = {
            email: user.email,
            name: user.name,
            lastname: user.lastName,
            phone: user.phone,
            zip: user.zipCode,
            lang: user.language,
            forced_lang: user.forced_lang,
            password: user.password,
            app_version: user.app_version,
            app_platform: user.app_platform,
            auth_id_google: user.auth_id_google,
            token_google: user.token_google,
            auth_id_facebook: user.auth_id_facebook,
            token_facebook: user.token_facebook,
            auth_id_apple: user.auth_id_apple,
            token_apple: user.token_apple,
            provider: user.provider,
            push_platform: user.pushPlatform,
            push_token: user.pushToken,
            activation_code: activationCode,
            accept_promos: user.accept_promos,
            accept_newsletter: user.accept_newsletter,
            job_profile: user.job_profile,
            id_reservation: id_reservation
        };
        return this.unauthenticatedApi.post('/user', JSON.stringify(payload))
            .toPromise().then(response => UserBuilder.buildUser(response.user));
    }
    requestNewPassword(email) {
        return this.unauthenticatedApi.get('/user/password_recovery', { email: email })
            .toPromise().then(response => response);
    }
    changePassword(currentPassword, newPassword, resetCode) {
        let payload = {
            current: currentPassword,
            new: newPassword,
            code: resetCode
        };
        return this.authenticatedApi.post('/user/password', JSON.stringify(payload))
            .toPromise().then(response => response);
    }
    resetPassword(newPassword, resetCode) {
        let payload = {
            password: newPassword,
            code: resetCode
        };
        return this.unauthenticatedApi.post('/user/reset_password', JSON.stringify(payload))
            .toPromise().then(response => response);
    }
    getUserPoints() {
        return this.authenticatedApi.get('/user/points').toPromise().then(response => {
            let pointsObject = response.points;
            return pointsObject ? pointsObject.currentpoints : null;
        });
    }
    resendValidationSMS() {
        return this.authenticatedApi.get('/user/smsvalidation')
            .toPromise().then(response => response);
    }
    resendValidationEmail() {
        return this.authenticatedApi.get('/user/email_validation')
            .toPromise().then(response => response);
    }
    checkEmailAvailable(email) {
        return this.unauthenticatedApi.get('/user/check_email_available', { email: email })
            .toPromise().then(response => {
            let emailAvailable = response.email_available;
            return emailAvailable ? emailAvailable : false;
        });
    }
    setDefaultInvoice(invoiceId) {
        return this.authenticatedApi.post(`/user/set_default_invoice_profile/${invoiceId}`).toPromise().then(response => {
            let token = getAuthToken(this.restClientConfig.useCookies, 'auth_token');
            token['user'] = response.user;
            setAuthToken(this.restClientConfig.useCookies, token, 'auth_token');
            return UserBuilder.buildUser(response.user);
        });
    }
    setForcedLang(lang) {
        return this.authenticatedApi.post(`/user/set_forced_lang/${lang}`).toPromise().then(response => {
            return UserBuilder.buildUser(response.user);
        });
    }
}
UsersApiService.ɵfac = function UsersApiService_Factory(t) { return new (t || UsersApiService)(i0.ɵɵinject(i1.AuthenticatedApiService), i0.ɵɵinject(i2.ApiService), i0.ɵɵinject(i3.RESTClientConfig)); };
UsersApiService.ɵprov = i0.ɵɵdefineInjectable({ token: UsersApiService, factory: UsersApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(UsersApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticatedApiService }, { type: i2.ApiService }, { type: i3.RESTClientConfig }]; }, null); })();
//# sourceMappingURL=users-api.service.js.map